module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-card-text', [_c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "400",
      "padding-right": "15px"
    }
  }, [_vm._v("Turnaround for campaigns - Filter by")]), _vm._v(" "), _c('v-btn-toggle', {
    attrs: {
      "small": "",
      "dense": "",
      "color": "info"
    },
    model: {
      value: (_vm.toggle_filter),
      callback: function($$v) {
        _vm.toggle_filter = $$v
      },
      expression: "toggle_filter"
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.monthlyClick(_vm.name)
      }
    }
  }, [_vm._v("\n                Monthly\n              ")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.quartelyClick(_vm.name)
      }
    }
  }, [_vm._v("\n                Quartely\n              ")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.yearlyClick(_vm.name)
      }
    }
  }, [_vm._v("\n                Yearly\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "9",
      "lg": "9"
    }
  }, [_c('canvas', {
    attrs: {
      "id": _vm.name,
      "width": "500",
      "height": "200"
    }
  })])], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "align": "end",
      "sm": "12",
      "md": "9",
      "lg": "9"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.detailClick(_vm.name)
      }
    }
  }, [_vm._v("Details")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46654f48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/CODashboard/Chart/Bar.vue
// module id = 2103
// module chunks = 0